import classnames from 'classnames/bind';

import { RECOMMEND_FLOAT_LIST } from '@portalCommon/constants';
import { OptimizedImg } from '@commonPackage/components';
import styles from './index.module.less';

const cx = classnames.bind(styles);

//  描述浮块
export function DescribeFloat() {
  return (
    <section className={cx('describe-float')}>
      {RECOMMEND_FLOAT_LIST.map(item => (
        <div className={cx('float-item')} key={item.ico}>
          <OptimizedImg loading="lazy" src={item.ico} alt={item.ico} />
          <div>
            <p>{item.text}</p>
            <p>{item.tip}</p>
          </div>
        </div>
      ))}
    </section>
  );
}
